module.exports = __webpack_public_path__ + "img/ysba.a845e789.png";